import React from 'react'
import {Modal} from "react-bootstrap"


function ModalOferta(props) {
    return (
      <Modal show={props.show} onHide={() => props.handleclose()} centered>
        <div className="p-xl-4 p-xxl-5">
          <Modal.Header closeButton>
            <Modal.Title>Oferta</Modal.Title>
          </Modal.Header>
          <Modal.Body>Pracujemy nad ofertą dla klientów biznesowych. Szczegóły wkrótce.</Modal.Body>
        </div>
      </Modal>
    )
}

export default ModalOferta
